'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Carousel", {
    enumerable: true,
    get: function() {
        return Carousel;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarousel = require("./useCarousel");
const _renderCarousel = require("./renderCarousel");
const _useCarouselStylesstyles = require("./useCarouselStyles.styles");
const _useCarouselContextValues = require("./useCarouselContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Carousel = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarousel.useCarousel_unstable)(props, ref);
    (0, _useCarouselStylesstyles.useCarouselStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselStyles_unstable')(state);
    const contextValues = (0, _useCarouselContextValues.useCarouselContextValues_unstable)(state);
    return (0, _renderCarousel.renderCarousel_unstable)(state, contextValues);
});
Carousel.displayName = 'Carousel';
